import * as TeamBlogActionTypes from '../../../constants/setting/TeamblogActionTypes';

const initialState = {
    searchKeyword : '',
    role : '',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case TeamBlogActionTypes.FILTER_ROLE:
            if(state.role !== action.role)
                return Object.assign({}, state, {
                    role: action.role
                });
            else
                return state;
        case TeamBlogActionTypes.SEARCH_KEYWORD:
            return Object.assign({}, state, {
                searchKeyword: action.searchKeyword
            });
        default :
            return state;
    }
}
